import { render, staticRenderFns } from "./trainAccount.vue?vue&type=template&id=dd0d9aa0&scoped=true&"
import script from "./trainAccount.vue?vue&type=script&lang=ts&"
export * from "./trainAccount.vue?vue&type=script&lang=ts&"
import style0 from "./trainAccount.vue?vue&type=style&index=0&id=dd0d9aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0d9aa0",
  null
  
)

export default component.exports